module.exports = "/assets/d85ed3402ea052b45d048843e758b93d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/WJ.png
// module id = 3081
// module chunks = 0